import { render, staticRenderFns } from "./NewLaboratoryForm.vue?vue&type=template&id=7e16db2e"
import script from "./NewLaboratoryForm.vue?vue&type=script&lang=js"
export * from "./NewLaboratoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports